export default [
    {
        "id": "comparison-tool",
        "plugin": "ComparisonTool",
        "pluginId": 10,
        "name": "comparison-tool",
        "html": require('./comparison-tool/html').default
    }
]